/**
 * Dinheiro do domínio Financeiro na tela e de volta.
 *
 * O valor persistido é sempre inteiro em centavos; a formatação é separada dele
 * (AGENTS §7.6). Estas duas funções são o único lugar onde a conversão
 * acontece, para que nenhuma tela arredonde por conta própria.
 */

const FORMATTER = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatCents(cents: number): string {
  return FORMATTER.format((cents || 0) / 100);
}

/**
 * Converte o que a pessoa digitou em centavos.
 *
 * Aceita "1234", "1.234,56", "R$ 1.234,56" e "1234.56". Devolve nulo quando não
 * há número válido ou quando o valor é negativo: o comando exige centavos
 * positivos, e recusar aqui evita mandar lixo para a validação do domínio.
 */
export function parseCents(input: string): number | null {
  const text = input.trim();
  if (!text) return null;
  if (/-/.test(text)) return null;
  const digits = text.replace(/[^\d.,]/g, "");
  if (!digits) return null;

  // O último separador manda: em "1.234,56" a vírgula é decimal; em "1234.56",
  // o ponto. Sem separador decimal, o número inteiro é em reais.
  const lastComma = digits.lastIndexOf(",");
  const lastDot = digits.lastIndexOf(".");
  const decimalAt = Math.max(lastComma, lastDot);
  const decimals = decimalAt >= 0 ? digits.length - decimalAt - 1 : 0;

  if (decimalAt >= 0 && decimals > 0 && decimals <= 2) {
    const whole = digits.slice(0, decimalAt).replace(/[.,]/g, "");
    const fraction = digits.slice(decimalAt + 1).padEnd(2, "0");
    const cents = Number(`${whole || "0"}${fraction}`);
    return Number.isFinite(cents) ? cents : null;
  }

  const whole = digits.replace(/[.,]/g, "");
  const cents = Number(whole) * 100;
  return Number.isFinite(cents) ? cents : null;
}
